<template>
  <job-preview-content-data-outline-sp
    :update-date="environment.updateDate"
    class="plr20 mt15 -company"
  >
    <div class="data-area pt20">
      <job-preview-content-pie-data-sp
        title="女性社員の割合"
        class="mb15"
        :value="environment.womanRate"
      />

      <job-preview-content-pie-data-sp
        title="女性役員・管理職の割合"
        class="pacentage-manage mb15"
        :value="environment.officerRate"
      />

      <job-preview-content-bar-data-sp
        title="残業時間（平均）"
        class="mb15"
        :value="environment.overtime"
        :average-value="average.environment.overtime"
        unit="時間"
      />

      <job-preview-content-bar-data-sp
        title="有給取得率"
        class="mb15"
        :value="environment.ptoRate"
        :average-value="average.environment.pto"
        unit="%"
      />

      <job-preview-content-bar-data-sp
        title="育休取得率"
        class="mb15"
        :value="environment.maternityRate"
        :average-value="average.environment.maternity"
        unit="%"
      />

      <job-preview-content-bar-data-sp
        title="女性社員の平均勤続年数"
        class="average-lengthofservice mb15"
        :value="environment.lengthService"
        :average-value="average.environment.lengthService"
        unit="年"
      />

      <!-- 国認定 -->
      <section
        v-if="certificateCount"
        class="data certificate mb20"
      >
        <p class="hd-type-04 mr5">
          <span>国認定</span>
        </p>
        <job-preview-content-data-tooltip-sp />
        <ul class="mt20">
          <li :class="environment.isKurumin ? 'on':''">
            くるみん
          </li>
          <li :class="environment.isPlatinumKurumin ? 'on':''">
            プラチナくるみん
          </li>
          <li :class="environment.isNadeshiko ? 'on':''">
            なでしこ銘柄
          </li>
          <li :class="environment.isEruboshi ? 'on':''">
            えるぼし
          </li>
        </ul>
      </section>

      <!-- その他の取り組み -->
      <section
        v-if="environment.womanAction"
        class="data other mb10"
      >
        <p class="hd-type-04 mr5">
          <span>その他の取り組み</span>
        </p>
        <p
          class="mt20 pega-pre-wrap"
          v-text="environment.womanAction"
        />
      </section>
    </div>
  </job-preview-content-data-outline-sp>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import JobPreviewContentDataOutlineSp from '@/components/atoms/JobPreviewContentDataOutlineSp'
import JobPreviewContentPieDataSp from '@/components/atoms/JobPreviewContentPieDataSp'
import JobPreviewContentBarDataSp from '@/components/atoms/JobPreviewContentBarDataSp'
import JobPreviewContentDataTooltipSp from '@/components/atoms/JobPreviewContentDataTooltipSp'

export default {
  components: {
    JobPreviewContentDataOutlineSp,
    JobPreviewContentPieDataSp,
    JobPreviewContentBarDataSp,
    JobPreviewContentDataTooltipSp
  },
  mixins: [jobPreviewCommon],
  props: {
    environment: {
      type: Object,
      required: true
    }
  }
}
</script>
